import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
// import { DefaultService } from 'api/default.service';
import { CatalogMainComponent } from 'src/app/components/catalog-main/catalog-main.component';
import { CatalogTreeComponent } from 'src/app/components/catalog-tree/catalog-tree.component';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit, OnDestroy {
  @ViewChild(CatalogMainComponent) catalog: CatalogMainComponent;
  private parametersObservable: any;
  categoryId: number = 1;
  lastId: number = 0;

  constructor(
    private activateRoute: ActivatedRoute,
    public meta: Meta,
    public title: Title,
    public appService: AppService
  ) { }
  ngOnDestroy(): void {
    if (this.parametersObservable != null) {
      this.parametersObservable.unsubscribe();
    }
  }
  refreshCategoryTree() {
    if (this.catalog) {
      this.catalog.fill(this.categoryId)
    }
  }
  setSEO() {
    this.meta.removeTag('name= "keywords"');
    this.meta.removeTag('name= "description"');
    if (this.appService.indexData && this.appService.indexData.attributes.HeaderTitle) {
      this.title.setTitle(this.appService.indexData.attributes.HeaderTitle)
      //this.title.setTitle('Catalog - ' + this.appService.indexData.attributes.HeaderTitle)
    }
  }
  ngOnInit(): void {
    this.parametersObservable = this.activateRoute.params.subscribe(params => {
      this.categoryId = params['id'] ? params['id'] : 1;
      this.lastId = params['lastId'] ? params['lastId'] : 0;
      this.refreshCategoryTree();
      this.setSEO()
    });
  }

}
